// Standardized copy translations used across dozens of tours. Falling back to these when the tour
// doesn't provide an explicit _es override keeps the UI fully bilingual without repeating text on every tour.
const CANNED_ES = {
  "Cancellations received 24 hours before will be 100% refundable.":
    "Cancelaciones recibidas 24 horas antes son 100% reembolsables.",
  "Valid driver's license (A1 or B1) required. Maximum weight: 120kg per ATV.":
    "Se requiere licencia de conducir válida (A1 o B1). Peso máximo: 120 kg por ATV.",
  "Valid driver's license (A1 or B1) required. Maximum weight: 200kg for double buggy.":
    "Se requiere licencia de conducir válida (A1 o B1). Peso máximo: 200 kg para buggy doble.",
  "Children over 4 years old welcome. Maximum weight: 120kg (265 lbs). Maximum waist circumference: 99cm (39 in).":
    "Niños mayores de 4 años bienvenidos. Peso máximo: 120 kg (265 lbs). Circunferencia máxima de cintura: 99 cm (39 in).",
  "ATV: Valid driver's license required, max 120kg. Zipline: Max 120kg, waist max 99cm.":
    "ATV: se requiere licencia de conducir válida, máx 120 kg. Zipline: máx 120 kg, cintura máx 99 cm.",
  "ATV: Valid driver's license required, max 120kg. Horseback: Max 100kg.":
    "ATV: se requiere licencia de conducir válida, máx 120 kg. Cabalgata: máx 100 kg.",
  "Zipline: Max 120kg, waist max 99cm. Horseback: Max 100kg.":
    "Zipline: máx 120 kg, cintura máx 99 cm. Cabalgata: máx 100 kg.",
  "ATV: Valid driver's license required, max 120kg. Boat tour: All ages welcome.":
    "ATV: se requiere licencia de conducir válida, máx 120 kg. Tour en bote: todas las edades bienvenidas.",
  "Zipline: Max 120kg, waist max 99cm. Boat tour: All ages welcome.":
    "Zipline: máx 120 kg, cintura máx 99 cm. Tour en bote: todas las edades bienvenidas.",
  "Buggy: Valid driver's license required, max 200kg total. Zipline: Max 120kg per person.":
    "Buggy: se requiere licencia de conducir válida, máx 200 kg total. Zipline: máx 120 kg por persona.",
  "ATV: Valid driver's license, max 120kg. Zipline: Max 120kg. Horseback: Max 100kg.":
    "ATV: licencia de conducir válida, máx 120 kg. Zipline: máx 120 kg. Cabalgata: máx 100 kg.",
  "ATV: Valid driver's license, max 120kg. Zipline: Max 120kg, waist max 99cm. Boat tour: All ages welcome.":
    "ATV: licencia de conducir válida, máx 120 kg. Zipline: máx 120 kg, cintura máx 99 cm. Tour en bote: todas las edades bienvenidas.",
  "Manuel Antonio National Park entrance MUST be booked online in advance by the client.":
    "La entrada al Parque Nacional Manuel Antonio DEBE ser reservada en línea con anticipación por el cliente.",
  "No experience necessary. Comfortable water shoes recommended. Total cost = $200 transport (up to 5 pax) + $20/extra passenger + $55/person kayak tour.":
    "No se requiere experiencia. Se recomienda calzado acuático cómodo. Costo total = $200 transporte (hasta 5 pax) + $20/pasajero extra + $55/persona por el tour en kayak.",
};

const translateIfCanned = (text) => (text && CANNED_ES[text.trim()]) || text;

// Returns a tour object with title/description/duration/highlights/requirements/policy
// localized to the given language, falling back to the default (English) fields.
export const localizeTour = (tour, language) => {
  if (!tour) return tour;
  const es = language === 'es';
  return {
    ...tour,
    title: es && tour.title_es ? tour.title_es : tour.title,
    description: es && tour.description_es ? tour.description_es : tour.description,
    duration: es && tour.duration_es ? tour.duration_es : tour.duration,
    highlights:
      es && tour.highlights_es && tour.highlights_es.length
        ? tour.highlights_es
        : tour.highlights,
    requirements: es
      ? (tour.requirements_es || translateIfCanned(tour.requirements))
      : tour.requirements,
    cancellation_policy: es
      ? (tour.cancellation_policy_es || translateIfCanned(tour.cancellation_policy))
      : tour.cancellation_policy,
  };
};
